// extracted by mini-css-extract-plugin
export default {"backgroundCityPanorama":"CityPanorama_backgroundCityPanorama__WFZsD","cityPanoramaImg":"CityPanorama_cityPanoramaImg__iGxSh"};